import { render, staticRenderFns } from "./acts-editor-state.vue?vue&type=template&id=4f2f8870"
import script from "./acts-editor-state.vue?vue&type=script&lang=js"
export * from "./acts-editor-state.vue?vue&type=script&lang=js"
import style0 from "./acts-editor-state.vue?vue&type=style&index=0&id=4f2f8870&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports